import axios from "axios";
import { IUser } from "../redux/api/types";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_URI_API,
    headers: {
        "Content-type": "application/json"
    },
});

axiosInstance.interceptors.request.use((config) => {

    const localStorageUser: IUser = JSON.parse(localStorage.getItem('user') ?? '{}')

    if (Object.keys(localStorageUser).length > 0 && localStorageUser.token) {
        config.headers['Authorization'] = `Bearer ${localStorageUser.token}`
    }
    
    return config;
}, (error) => {

    if (error.response.status === 401) {
        localStorage.clear()
    }

    return Promise.reject(error);
}
);

axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default axiosInstance